<bz-button variant="tertiary"
           appBringozIdGenerator="bringozFilterBtn"
           class="primary-102"
           [disabled]="isDisabled"
           (clicked)="openDialog($event)">

  <bz-icon class="icon-color" [icon]="icons.filter"></bz-icon>

  <span *ngIf="!hasFilters()"
        class="br-head-1 br-body-2 primary-102">{{'Set Filters' | translate}}</span>

  <div *ngIf="!hideDisplay && !!hasFilters()"
       class="overflow-auto full-height layout-row layout-align-start-center">

    <!--Date Range Template-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.dateRangeTemplateType !== undefined">
      <span class="margin-left-5 margin-right-5">{{'DATE_RANGE_TYPE.' + filters.dateRangeTemplateType | translate}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('dateRangeTemplateType'); $event.stopPropagation()"></bz-icon>

    </div>

    <!--Service Types-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.serviceTypes?.length">
      <span class="margin-right-5">{{filters.serviceTypes.length === 1 ? ('X_SERVICE_TYPE' | translate: {length: filters.serviceTypes.length}) : ('X_SERVICE_TYPES' | translate: {length: filters.serviceTypes.length})}}</span>


      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('serviceTypes'); $event.stopPropagation()"></bz-icon>

    </div>

    <!--Configured Package Name-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.configuredFieldName !== undefined">
      <span class="margin-right-5 text-ellipsis">{{filters.configuredFieldName | bringozPackageField}}</span>


      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('configuredFieldName'); $event.stopPropagation()"></bz-icon>

    </div>

    <!--Configured Package Value-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.configuredFieldValue !== undefined">
      <span class="margin-right-5 text-ellipsis">{{filters.configuredFieldValue}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('configuredFieldValue'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Approval statuses-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.approvalStatuses?.length">
      <span class="margin-right-5">{{filters.approvalStatuses.length === 1 ? ('X_APPROVAL_STATUS' | translate: {length: filters.approvalStatuses.length}) : ('X_APPROVAL_STATUSES' | translate: {length: filters.approvalStatuses.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('approvalStatuses'); $event.stopPropagation()"></bz-icon>

    </div>

    <!--Approval statuses-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.billingOrderInvoiceStatuses?.length">
      <span class="margin-right-5">{{filters.billingOrderInvoiceStatuses.length === 1 ? ('X_BILLING_ORDER_INVOICE_STATUS' | translate: {length: filters.billingOrderInvoiceStatuses.length}) : ('X_BILLING_ORDER_INVOICE_STATUSES' | translate: {length: filters.billingOrderInvoiceStatuses.length})}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('billingOrderInvoiceStatuses'); $event.stopPropagation()"></bz-icon>

    </div>

    <!--Branches-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.branchId">
      <span class="margin-left-5 margin-right-5">{{'X_BRANCH' | translate}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('branchId'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Branches-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.branchIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.branchIds.length === 1 ? ('X_BRANCH' | translate: {length: filters.branchIds.length}) : ('X_BRANCHES' | translate: {length: filters.branchIds.length})}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('branchIds'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Agent Branches-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.agentBranchIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.agentBranchIds.length === 1 ? ('X_AGENT_BRANCH' | translate: {length: filters.agentBranchIds.length}) : ('X_AGENT_BRANCHES' | translate: {length: filters.agentBranchIds.length}) }}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('agentBranchIds'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Groups-->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.groupIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.groupIds.length === 1 ? ('X_GROUP' | translate: {length: filters.groupIds.length}) : ('X_GROUPS' | translate: {length: filters.groupIds.length})  }}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('groupIds'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Resources-->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.resourceIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.resourceIds.length === 1 ? ('X_RESOURCE' | translate: {length: filters.resourceIds.length}) : ('X_RESOURCES' | translate: {length: filters.resourceIds.length}) }}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('resourceIds'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Depots-->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.depotIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.depotIds.length === 1 ? ('X_DEPOT' | translate: {length: filters.depotIds.length}) : ('X_DEPOTS' | translate: {length: filters.depotIds.length}) }}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('depotIds'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Accounts-->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.accountIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.accountIds.length === 1 ? ('X_ACCOUNT' | translate: {length: filters.accountIds.length}) : ('X_ACCOUNTS' | translate: {length: filters.accountIds.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('accountIds'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--logistics Vehicle -->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.logisticsVehicleIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.logisticsVehicleIds.length === 1 ? ('X_VEHICLE' | translate: {length: filters.logisticsVehicleIds.length}) : ('X_VEHICLES' | translate: {length: filters.logisticsVehicleIds.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('logisticsVehicleIds'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Service Areas-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noArea || filters.serviceAreaIds?.length">
      <span class="margin-left-5 margin-right-5"
            *ngIf="filters.noArea">{{'No service area' | translate}} {{filters.serviceAreaIds.length ? '+' : ''}}</span>

      <span class="margin-left-5 margin-right-5"
            *ngIf="filters.serviceAreaIds?.length">{{filters.serviceAreaIds.length === 1 ? ('X_SERVICE_AREA' | translate: {length: filters.serviceAreaIds.length}) : ('X_SERVICE_AREAS' | translate: {length: filters.serviceAreaIds.length}) }}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('serviceAreaIds'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Labels-->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.labels?.length">
      <span class="margin-left-5 margin-right-5">{{filters.labels.length === 1 ? ('X_LABEL' | translate: {length: filters.labels.length}) : ('X_LABELS' | translate: {length: filters.labels.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('labels'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Tags-->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.tags?.length">
      <span class="margin-left-5 margin-right-5">{{filters.tags.length === 1 ? ('X_TAG' | translate: {length: filters.tags.length}) : ('X_TAGS' | translate: {length: filters.tags.length}) }}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('tags'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Vehicle Types-->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.vehicleTypeIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.vehicleTypeIds.length === 1 ? ('X_VEHICLE_TYPE' | translate: {length: filters.vehicleTypeIds.length}) : ('X_VEHICLE_TYPES' | translate: {length: filters.vehicleTypeIds.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('vehicleTypeIds'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Vehicle Class-->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.vehicleTypes?.length">
      <span class="margin-left-5 margin-right-5">{{filters.vehicleTypes.length === 1 ? ('X_VEHICLE_CLASS' | translate: {length: filters.vehicleTypes.length}) : ('X_VEHICLE_CLASSES' | translate: {length: filters.vehicleTypes.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('vehicleTypes'); $event.stopPropagation()"></bz-icon>
    </div>

    <!-- fulfillment Status -->
    <div class="filter-item layout-row layout-align-start-center" *ngIf="filters.fulfillmentDisplayStatus?.length">
      <span class="margin-left-5 margin-right-5">{{filters.fulfillmentDisplayStatus.length === 1 ? ('X_FULFILLMENTSTATUS' | translate: {length: filters.fulfillmentDisplayStatus.length}) : ('X_FULFILLMENTSTATUSES' | translate: {length: filters.fulfillmentDisplayStatus.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('fulfillmentDisplayStatus'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--fulfillment Display Step Status-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.fulfillmentStepDisplayStatus?.length">
      <span class="margin-left-5 margin-right-5">{{filters.fulfillmentStepDisplayStatus.length === 1 ? ('X_FULFILLMENTSTEPSTATUS' | translate: {length: filters.fulfillmentStepDisplayStatus.length}) : ('X_FULFILLMENTSTEPSTATUSES' | translate: {length: filters.fulfillmentStepDisplayStatus.length}) }}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('fulfillmentStepDisplayStatus'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Fulfillment mile-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.fulfillmentMileType">
      <span class="margin-left-5 margin-right-5">{{'FULFILLMENT_MILES.' + filters.fulfillmentMileType | translate}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('fulfillmentMileType'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--dispatch type-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.dispatchType">
      <span class="margin-left-5 margin-right-5">{{filters.dispatchType === fulfillmentSubTypeType.Dispatch ? 'Internal' : 'External' | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('dispatchType'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Carriers-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.supplyAccountIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.supplyAccountIds.length === 1 ? ('X_CARRIER' | translate: {length: filters.supplyAccountIds.length}) : ('X_CARRIERS' | translate: {length: filters.supplyAccountIds.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('supplyAccountIds'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Agent Type-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.agentType !== undefined">
      <span class="margin-left-5 margin-right-5">{{'AGENT_TYPES.' + filters.agentType | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('agentType'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Employment Type-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.employmentType !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.employmentType | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('employmentType'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Agent Status-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.agentStatus !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.agentStatus | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('agentStatus'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Route Status-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.routeStatuses !== undefined">
      <span
              class="margin-left-5 margin-right-5">{{filters.routeStatuses.length === 1 ? (filters.routeStatuses[0] | translate) : ('X_ROUTE_STATUSES' | translate: {length: filters.routeStatuses.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('routeStatuses'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Billing Accounts-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.billingAccountIds?.length">
      <span
              class="margin-left-5 margin-right-5">{{filters.billingAccountIds.length === 1 ? ('X_BILLING_ACCOUNT' | translate: {length: filters.billingAccountIds.length}) : ('X_BILLING_ACCOUNTS' | translate: {length: filters.billingAccountIds.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('billingAccountIds'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Billing Order Status-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.billingOrderStatus !== undefined">
      <span
              class="margin-left-5 margin-right-5">{{'ORDER_STATUS_TYPE.' + filters.billingOrderStatus | translate}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('billingOrderStatus'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--logistics Vehicle Statuses-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.logisticsVehicleStatus !== undefined">
      <span
              class="margin-left-5 margin-right-5">{{filters.logisticsVehicleStatus | translate}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('logisticsVehicleStatus'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Agent Skills-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.agentSkills?.length">
      <span
              class="margin-left-5 margin-right-5">{{filters.agentSkills.length === 1 ? ('X_AGENT_SKILL' | translate: {length: filters.agentSkills.length}) : ('X_AGENT_SKILLS' | translate: {length: filters.agentSkills.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('agentSkills'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Agent Assistant-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.agentAssistant !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.agentAssistant ? ('Assistant Agents' | translate) : ('Primary Agents' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('agentAssistant'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Agents-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.agentIds?.length">
      <span
              class="margin-left-5 margin-right-5">{{filters.agentIds.length === 1 ? ('X_AGENT' | translate: {length: filters.agentIds.length}) : ('X_AGENTS' | translate: {length: filters.agentIds.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('agentIds'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Risk Types-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.riskTypes?.length">
      <span
              class="margin-left-5 margin-right-5">{{filters.riskTypes.length === 1 ? ('X_RISK_TYPE' | translate: {length: filters.riskTypes.length}) : ('X_RISK_TYPES' | translate: {length: filters.riskTypes.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('riskTypes'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Program Types-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.programTypes?.length">
      <span
              class="margin-left-5 margin-right-5">{{filters.programTypes.length === 1 ? ('X_PROGRAM_TYPE' | translate: {length: filters.programTypes.length}) : ('X_PROGRAM_TYPES' | translate: {length: filters.programTypes.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('programTypes'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Dispatch Quote Types-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.dispatchQuoteTypes?.length">
      <span class="margin-left-5 margin-right-5">{{filters.dispatchQuoteTypes.length === 1 ? ('X_DISPATCH_QUOTE_TYPE' | translate: {length: filters.dispatchQuoteTypes.length}) : ('X_DISPATCH_QUOTE_TYPES' | translate: {length: filters.dispatchQuoteTypes.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('dispatchQuoteTypes'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Package Type-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.packagesIds?.length">
      <span class="margin-left-5 margin-right-5">{{filters.packagesIds.length === 1 ? ('X_PACKAGE_TYPE' | translate: {length: filters.packagesIds.length}) : ('X_PACKAGE_TYPES' | translate: {length: filters.packagesIds.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('packagesIds'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Reason Type-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.reasonType?.length">
      <span class="margin-left-5 margin-right-5">{{filters.reasonType.length === 1 ? ('X_REASON_TYPE' | translate: {length: filters.reasonType.length}) : ('X_REASON_TYPES' | translate: {length: filters.reasonType.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('reasonType'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Provider Type-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.providerTypes?.length">
      <span class="margin-left-5 margin-right-5">{{filters.providerTypes.length === 1 ? ('X_PROVIDER_TYPE' | translate: {length: filters.providerTypes.length}) : ('X_PROVIDER_TYPES' | translate: {length: filters.providerTypes.length}) }}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('providerTypes'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Attempts-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.attempts !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.attempts}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('attempts'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Routed-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.inRoute !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.inRoute ? ('Routed' | translate) : ('Not Routed' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('inRoute'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Filtered By Created At-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.filterByCreatedAt !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.filterByCreatedAt ? ('Filtered by Created At' | translate) : ('Not Filtered by Created At' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('filterByCreatedAt'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Assigned tasks-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.hasScheduledTasks !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.hasScheduledTasks ? ('Has Scheduled Tasks' | translate) : ('No Scheduled Tasks' | translate)}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('hasScheduledTasks'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--hasPrice-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.hasPrice !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.hasPrice ? ('Has Price' | translate) : ('Missing Price' | translate)}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('hasPrice'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Packed-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.isPacked !== undefined">

      <span class="margin-left-5 margin-right-5">{{filters.isPacked ? ('Packed' | translate) : ('Not Packed' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('isPacked'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Address Quality-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.addressQualities?.length">
      <span class="margin-left-5 margin-right-5">{{filters.addressQualities.length === 1 ? ('X_ADDRESS_QUALITY' | translate: {length: filters.addressQualities.length}) : ('X_ADDRESS_QUALITIES' | translate: {length: filters.addressQualities.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('addressQualities'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Packing Statuses-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.packingStatuses?.length">
      <span class="margin-left-5 margin-right-5">{{filters.packingStatuses.length === 1 ? ('X_PACKING_STATUS' | translate: {length: filters.packingStatuses.length}) : ('X_PACKING_STATUSES' | translate: {length: filters.packingStatuses.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('packingStatuses'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Is Missing Packages-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.isMissingPackages !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.isMissingPackages ? ('Missing Packages' | translate) : ('No Missing Packages' | translate)}}</span>


      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('isMissingPackages'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--isActive-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.isActive !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.isActive ? ('Active' | translate) : ('Not Active' | translate)}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('isActive'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--isArchived-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.isArchived !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.isActive ? ('Archived' | translate) : ('Not Archived' | translate)}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('isArchived'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--scheduleRequired-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.schedulingRequired !== undefined">

      <span class="margin-left-5 margin-right-5">{{filters.schedulingRequired ? ('Schedule required' | translate) : ('Schedule not required' | translate)}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('schedulingRequired'); $event.stopPropagation()"></bz-icon>

    </div>

    <!--GPS STATUS-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.gpsStatus !== undefined">
      <span class="margin-left-5 margin-right-5">{{filters.gpsStatus ? ('GPS enabled' | translate) : ('GPS disabled' | translate)}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('gpsStatus'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Agent Gps Permission-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.gpsPermissions?.length">
      <span class="margin-left-5 margin-right-5">{{filters.gpsPermissions.length === 1 ? ('X_GPS_PERMISSION' | translate: {length: filters.gpsPermissions.length}) : ('X_GPS_PERMISSIONS' | translate: {length: filters.gpsPermissions.length})}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('gpsPermissions'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Pickup Service Areas -->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noPickUpArea === false">

      <span class="margin-left-5 margin-right-5">{{'Pickup service areas' | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('noPickUpArea'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Dropoff Service Areas -->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noDropOffArea === false">
      <span class="margin-left-5 margin-right-5">{{'Dropoff service areas' | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('noDropOffArea'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Pickup Accounts -->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noPickUpAccount === false">
      <span class="margin-left-5 margin-right-5">{{'Pickup accounts' | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('noPickUpAccount'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Dropoff Accounts -->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noDropOffAccount === false">
      <span class="margin-left-5 margin-right-5">{{'Dropoff accounts' | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('noDropOffAccount'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Pickup Depots -->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noPickUpDepot === false">
      <span class="margin-left-5 margin-right-5">{{'Pickup depots' | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('noPickUpDepot'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--Dropoff Depots -->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noDropOffDepot === false">
      <span class="margin-left-5 margin-right-5">{{'Dropoff depots' | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('noDropOffDepot'); $event.stopPropagation()"></bz-icon>
    </div>


    <!--No pickup address -->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noFromLocation === false">
      <span class="margin-left-5 margin-right-5">{{filters.noFromLocation ? ('No pick-up address' | translate) : ('Pick-up address exists' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('noFromLocation'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--No dropoff address -->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.noToLocation === false">
      <span class="margin-left-5 margin-right-5">{{filters.noToLocation ? ('No drop-off address' | translate) : ('Drop-off address exists' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('noToLocation'); $event.stopPropagation()"></bz-icon>
    </div>

    <!-- Return Delivery-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.isReturnDelivery === false">
      <span class="margin-left-5 margin-right-5">{{filters.isReturnDelivery ? ('Return delivery' | translate) : ('Not return delivery' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('isReturnDelivery'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--obligateTimeWindow-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.obligateTimeWindow === false">
      <span class="margin-left-5 margin-right-5">{{filters.obligateTimeWindow ? ('Obligate' | translate) : ('Not obligate' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('obligateTimeWindow'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--timeToDeliver-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.timeToDeliver === false">
      <span class="margin-left-5 margin-right-5">{{filters.timeToDeliver | translate}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('timeToDeliver'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--isConsolidated-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.isConsolidated === false">
      <span class="margin-left-5 margin-right-5">{{filters.isConsolidated ? ('Consolidated' | translate) : ('Not Consolidated' | translate)}}</span>
      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('isConsolidated'); $event.stopPropagation()"></bz-icon>
    </div>

    <!--Commission Delta-->
    <div class="filter-item layout-row layout-align-start-center"
         *ngIf="filters.commissionDelta !== undefined">
      <span class="margin-left-5 margin-right-5">{{'COMMISSION_DELTA_TYPE.' + filters.commissionDelta | translate}}</span>

      <bz-icon class="pointer icon-color" size="md" [icon]="icons.reset" [label]="'Reset' | translate"
                    (click)="onResetFilter('commissionDelta'); $event.stopPropagation()"></bz-icon>

    </div>

  </div>

  <div *ngIf="!!hasFilters()" class="has-filter-indication"></div>
</bz-button>
